import { useParams } from "react-router-dom";

import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";

import { useMaterialDirectoryDetail } from "../../api/materialsApi";
import { downloadLink } from "../../api";
import { Tooltip } from "react-tooltip";

const StudentMaterial = () => {
  const { directory, department } = useParams();
  const { data: materialDirectoryDetail } = useMaterialDirectoryDetail({
    department,
    directory,
  });

  if (!materialDirectoryDetail) {
    return <div>로딩 중...</div>;
  }

  return (
    <>
      {materialDirectoryDetail.notice && (
        <p className="notice">{materialDirectoryDetail.notice}</p>
      )}
      {materialDirectoryDetail.files.map(
        ({ filename, signed_url }: { filename: string; signed_url: string }) =>
          signed_url ? (
            <a
              href={signed_url}
              target="_self"
              rel="noreferrer"
              className="material-download"
            >
              📂 {filename}
              <FileDownloadOutlinedIcon />
            </a>
          ) : (
            <div
              className="material-download no-link"
              data-tooltip-id={`no-link-${filename}`}
            >
              <p className="download-link">📂 {filename}</p>
              <Tooltip id={`no-link-${filename}`} place="right">
                자료가 없습니다.
              </Tooltip>
            </div>
          )
      )}
    </>
  );
};

export default StudentMaterial;
